import React, { useState } from 'react';

import { styles } from './styles';

const FileDropZone = ({ tag, onFileSelect, allowedExtensions }) => {
  const [dragging, setDragging] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    onFileSelect(file);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (allowedExtensions.includes('*') || allowedExtensions.includes(fileExtension)) {
        setSelectedFile(file);
        onFileSelect(file);
      } else {
        alert(`Invalid file type. Allowed extensions: ${allowedExtensions.join(', ')}`);
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      style={{
        ...styles.container,
        border: dragging ? '2px dashed #007bff' : '2px dashed #ccc',
        backgroundColor: dragging ? '#f0f8ff' : '#f9f9f9',
      }}
    >
      {selectedFile ? (
        <p>
          <strong>Selected File:</strong> {selectedFile.name}
        </p>
      ) : (
        <p>Drag and drop the {tag} file here or click below to choose</p>
      )}
      <label htmlFor={tag}>
        <button style={styles.button} onClick={() => document.getElementById(tag).click()}>
          {tag} (Allowed: {allowedExtensions.join(', ')})
        </button>
      </label>
      <input
        id={tag}
        type="file"
        accept={
          allowedExtensions.includes('*')
            ? undefined
            : allowedExtensions.map((ext) => `.${ext}`).join(',')
        }
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default FileDropZone;
